import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=5cc31aaa&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc31aaa')) {
      api.createRecord('5cc31aaa', component.options)
    } else {
      api.reload('5cc31aaa', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=5cc31aaa&", function () {
      api.rerender('5cc31aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ASY7YVnoZQBa/JS/imageCarousel.vue"
export default component.exports